// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-checkbox[data-v-0da18575]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:1px solid #000;width:15px;height:15px;margin-top:5px}svg[data-v-0da18575]{position:absolute;top:7px;left:2px}svg.svg-error line[data-v-0da18575],svg.svg-error path[data-v-0da18575]{stroke:red}svg.svg-disabled line[data-v-0da18575],svg.svg-disabled path[data-v-0da18575]{stroke:#c4c4c4}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
